export var sourceCodeEnum;

(function (sourceCodeEnum) {
  sourceCodeEnum["weixin"] = "100";
  sourceCodeEnum["dingding"] = "104";
})(sourceCodeEnum || (sourceCodeEnum = {}));